module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAXCAYAAAD+4+QTAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CHAQLOiCKtrMAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAA30lEQVRIS7WSWw4CIQxF8YfENbgWN+Yy3Ia/rk9NgQstFAam2OQkw+seSsbN1eUr2Vos2H8i/5Dc/DOQJXtFsQNIhCitpY2W6giEyFRtF5xtEi0cFMlp0bgLwvhkukCbN0lEkBKe184/WSvhY47hyXCzgiYgDBJeYwlheDLUWEDIbpZFx10Akjzu10qEb4xD8ckIHdRCwfvlA7QPiAzRZZrEYYz54RqEc0kORHgt4TfUQBBAFwStN8GcWckINRgEQZKsiNSwHlGAmv+TDkmXLuQqk1p4j4lgrerNK/TKuR8m1Rymbl35QQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/magic-icon.png
// module id = 496
// module chunks = 0